import classNames from 'classnames';
import { ElementType, FC } from 'react';

import { IllLError, IllLSuccessGreen, IllLSuccessInfo } from '../assets/illustrations';
import styles from './StatusIllustration.styles.m.css';

type TStatusIllustrationStatus = 'success' | 'success-info' | 'error';

interface IStatusIllustrationProps {
  status: TStatusIllustrationStatus;
  className?: string;
}

const ILLUSTRATIONS_MAP: Record<TStatusIllustrationStatus, ElementType> = {
  success: IllLSuccessGreen,
  'success-info': IllLSuccessInfo,
  error: IllLError,
};

export const StatusIllustration: FC<IStatusIllustrationProps> = (props) => {
  const { status, className } = props;
  const Illustration = ILLUSTRATIONS_MAP[status];

  if (!Illustration) {
    return null;
  }

  const containerClassName = classNames(styles.container, className);

  return <Illustration className={containerClassName} />;
};
